export default __webpack_public_path__ + "static/media/chillTechTabloidLight.cf0e880e.png";